interface Props {
    callback: (params: object) => void | undefined
    params: object
}

export default function hook(node: HTMLElement, props: Props){
    let prevState = "";
    function deepCompare(data: Props){
        return prevState === JSON.stringify(data);
    }

    function callback(data: Props) {
        if (data.callback && !deepCompare(data)) {
            prevState = JSON.stringify(data);
            try {
                data.callback({element: node, ...data.params});
            } catch (e) {
                console.error("callback error", e);
            }
        }
    }

    callback(props);

    return {
        update: (props: Props) => {
            callback(props);
        }
    }
}